export interface ContentState {
    activeContent: ActiveContent;
    isSidebarExpanded: boolean;
    isAppLoading: boolean
    loadingText: string
}

export interface AppLoadingInput {
    isAppLoading: boolean;
    loadingText: string;
}

export enum ActiveContent {
    Adventure = "Adventure",
    AdventureCreate = "Adventure Create",
    AdventureMask = "Adventure Mask",
    Dashboard = "Dashboard",
    Standardinhalte = "Standardinhalte",
    Voelker = "Völker",
    Subvoelker = "Subvölker",
    Klassen = "Klassen",
    Subklassen = "Subklassen",
    Manatabellen = "Manatabellen",
    Registrierung = "Registrierung",
    Autorisierung = "Autorisierung",
    Kampagne = "Kampagne",
    KampagnePlay = "Kampagne spielen",
    Testpage = "Testpage"
}